import { __decorate } from "tslib";
import OnlinePBXService from '@/Integrations/VoIP/onlinepbx';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapActions, mapGetters } from 'vuex';
import OngoingCallComponent from './OngoingCallComponent.vue';
let CallButton = class CallButton extends Vue {
    customer;
    findIntegrationsFromStore;
    getMyCompanyFromStore;
    getMyCompany;
    findIntegrations;
    callState = 'default';
    get myCompany() {
        const company = this.getMyCompanyFromStore('mine') || {};
        this.findIntegrations({ query: { companyId: company.id } });
        return company;
    }
    get integrations() {
        const response = this.findIntegrationsFromStore({ query: { companyId: this.myCompany.id } });
        const integrations = response.data[0];
        return integrations || null;
    }
    get isOnlinePBXIntegrated() {
        return this.integrations && this.integrations.onlinePBX && this.integrations.onlinePBX.apiKey;
    }
    created() {
        this.getMyCompany(['mine', { skipRequestIfExists: false }]);
    }
    async startCall() {
        if (!this.isOnlinePBXIntegrated)
            return;
        this.$bvToast.show('ongoing-call-component');
        this.callState = 'initializing';
        // @ts-ignore
        const voip = OnlinePBXService.getInstance(this.integrations.onlinePBX.domain, this.integrations.onlinePBX.apiKey);
        const callResponse = await voip.createPhoneCall(this.customer.phone);
        if (!callResponse) {
            this.callState = 'default';
            return;
        }
        if (callResponse.status == 1) {
            this.callState = 'ongoing';
        }
        else {
            this.callState = 'failed';
            console.log('call state', callResponse);
        }
    }
};
__decorate([
    Prop({ type: Object, required: true })
], CallButton.prototype, "customer", void 0);
CallButton = __decorate([
    Component({
        components: {
            OngoingCallComponent,
        },
        computed: {
            ...mapGetters('my-company', { getMyCompanyFromStore: 'get' }),
            ...mapGetters('integrations', { findIntegrationsFromStore: 'find' }),
        },
        methods: {
            ...mapActions('my-company', {
                getMyCompany: 'get'
            }),
            ...mapActions('integrations', {
                findIntegrations: 'find'
            }),
        }
    })
], CallButton);
export default CallButton;
